import Box from "@mui/material/Box";

import {LayoutType} from "~/layouts/pageContents/types";

export const ContentBody: React.FC<LayoutType> = ({children}) => <Box>{children}</Box>;
